import {
    EKanbanCardProperty,
    EMPTY_ARRAY,
    IApplicationState,
    TBoardId,
    TKanbanCardProperty
} from '../../../../types/types';
import { getBoardMeta } from './getBoardMeta';

export const getBoardDefaultCardPreviewHiddenProperties = (
    state: IApplicationState,
    boardId: TBoardId,
): TKanbanCardProperty[] => {
    const meta = getBoardMeta(state, boardId);
    return meta && meta.defaultCardPreviewHiddenProperties || EMPTY_ARRAY;
};
